$(function() {

  // scroll down
  if ( $('#js-scrolldown').length != 0 ) {
    let $nav_height = $('#header').innerHeight();
    $('#js-scrolldown').click(function() {
        var target = $(this.hash);
        $('html, body').animate({
            scrollTop: target.offset().top - $nav_height
        }, 1000);
        return false;
    });
  }

  // 首頁輪播
  if ( $('#indexBanner').length != 0 ) {
    var indexBanner = new Swiper('#indexBanner', {
      effect: 'fade',
      autoplay: {
        delay: 5000,
      },
      loop: true,
      peed: 1000,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
    });
  }

  // 最新消息輪播
  if ( $('#homeNewsSwiper').length != 0 ) {
    var homeNewsSwiper = new Swiper("#homeNewsSwiper", {
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        prevEl: ".home-news-swiper-wrap .swiper-button-prev",
        nextEl: ".home-news-swiper-wrap .swiper-button-next",
      },
      breakpoints: {
        1025: { // >= 1025px 時
          slidesPerView: 2.5,
          spaceBetween: 68,
          slidesOffsetAfter: 80,
        },
        641: { // >= 641px 時
          slidesPerView: 1.5,
          spaceBetween: 38,
          slidesOffsetAfter: 60,
        }
      },
    });
  }

});